module.exports = __webpack_public_path__ + "static/img/raghav-112.e86e227.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/raghav-112.jpg
// module id = 628
// module chunks = 2